import { createSelector, createFeatureSelector } from '@ngrx/store';
import { CaseState } from '../../interfaces/interfaces';

export const selectCaseState = createFeatureSelector<CaseState>('caseReducer');

export const selectPatient = createSelector(
  selectCaseState,
  (state) => state.case.patient
);

export const selectMainVehicleLog = createSelector(
  selectCaseState,
  (state) => state.case.mainVehicleLog
);

export const selectCaseNo = createSelector(
  selectCaseState,
  (state) => state.case.caseNo
);

export const selectPatientFile = createSelector(
  selectCaseState,
  (state) => state.case.patientFile
);

export const selectIsLabmedSend = createSelector(
  selectCaseState,
  (state) => state.case.isSendLabmed
);

export const selectReadonly = createSelector(
  selectCaseState,
  (state) => state.isReadonly
);

export const selectUserInFile = createSelector(
  selectCaseState,
  (state) => state.userInFile
);
export const selectCaseType = createSelector(
  selectCaseState,
  (state) => state.case.caseType
);

export const selectRecordType = createSelector(
  selectCaseState,
  (state) => state.case.recordType
);
export const selectCaseDate = createSelector(
  selectCaseState,
  (state) => state.case.caseDate
);

export const selectAppointmentInfos = createSelector(
  selectCaseState,
  (state) => ({
    appointmentStartDate: state.case.appointmentStartDate,
    appointmentEndDate: state.case.appointmentEndDate,
    appointmentDuration: state.case.appointmentDuration,
    plannedVehicle:state?.case?.plannedVehicle ?? null,
    plannedStaff:state?.case?.plannedStaff ?? null
  })
);

export const selectCaseId = createSelector(
  selectCaseState,
  (state) => state.case.id
);
export const selectAppointentChilds = createSelector(
  selectCaseState,
  (state) => state.case.childAppointments
);

export const selectCaseUid = createSelector(
  selectCaseState,
  (state) => state.case.uid
);

export const selectCaseStatus = createSelector(
  selectCaseState,
  (state) => state.case.caseStatus
);

export const selectCaseApproved = createSelector(
  selectCaseState,
  (state) => state.case.isCaseApproved
);

export const selectIsExcelData = createSelector(
  selectCaseState,
  (state) => state?.case?.isExcelData
);

export const selectAppointmentStatus = createSelector(
  selectCaseState,
  (state) => state.case.appointmentStatus
);

export const selectCaseCreateDate = createSelector(
  selectCaseState,
  (state) => state.case.createdAt
);

export const selectBlackList = createSelector(
  selectCaseState,
  (state) => state.blackList
);

export const selectLoading = createSelector(
  selectCaseState,
  (state) => state.loading
);
export const selectError = createSelector(
  selectCaseState,
  (state) => state.error
);


export const selectCerebralDatas = createSelector(
  selectCaseState,
  (state) => ({
    isSendCerebral: state.case.isSendCerebral,
    patient:{
      gender: state.case.patientInformations?.gender,
      birthDate:state.case.patientInformations?.birthDate,
      idNumber:state.case.patientInformations?.idNumber
    }
  }));

export const selectCaseCancelInformations=createSelector( selectCaseState,
  (state) => ({
    cancelReason: state.case.cancelReason,
    cancelDescription: state.case.cancelDescription,
  })
);
